export interface IPlanActions {
  applicant_personal_data?: boolean;
  candidate_personal_data?: boolean;
  online_chat?: boolean;
}

export interface IPlanPrice {
  _id?: string;
  additional_weeks?: number;
  bonus?: number;
  month?: number;
  price?: number;
}

export interface IPlanProfit {
  adv?: number;
  free_partners?: number;
  level_1?: number;
  level_2?: number;
  level_3?: number;
}

export interface IPlan {
  _id?: string;
  name?: string;
  partner_registration_price?: number;
  actions?: IPlanActions;
  price?: IPlanPrice[];
  partners_profit?: IPlanProfit;
}

export class Plan {
  _id?: string;
  name?: string;
  partner_registration_price?: number;
  actions?: IPlanActions;
  price?: IPlanPrice[];
  partners_profit?: IPlanProfit;

  constructor( plan: IPlan = {} ) {
    this._id = plan._id;
    this.name = plan.name;
    this.partner_registration_price = plan.partner_registration_price;
    this.actions = plan.actions || {};
    this.price = plan.price || [];
    this.partners_profit = plan.partners_profit || {};
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/plan.ts